import React from "react";
import styles from './index.module.scss'
import Form from "@/wmCompoments/form";
import QuestionType from "./compoment/questionTypeFiled";
import OrderFiled from "./compoment/orderFiled";
import ContentDescribe from "./compoment/contentDescribe";
import UploadErrorImage from "./compoment/uploadErrorImage";
import SubmitButton from "@/modals/login/submitButton";
import { useAddFeedBack } from "./hooks/api";
import Toast from "@/wmCompoments/toast";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import Button from "@/wmCompoments/button";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const FeedBack = () => {
    const { t } = useTranslation('feedback')

    const { trigger, isMutating } = useAddFeedBack()

    const navigate = useNavigate()

    const onSubmit = async (v) => {
        try {
            await trigger({
                category: v?.type?.category,
                clientVision: 'web',
                content: v?.desc,
                description: v?.desc,
                device: 'web',
                deviceVision: process.env.REACT_APP_VERSION + '--' + process.env.REACT_APP_LNG_VERSION,
                orderNo: v?.order?.billNo,
                picUrls: !!v?.images?.length ? v?.images?.map((v) => v.url)?.toString?.() : ''
            })
            Toast.show(t('feedbackSuccess'))
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    const onClickMyFeedback = () => {
        navigate('/mine/myFeedback')
    }


    return <div className={styles.warpper}>
        <div className={styles.top}>
            <span className={styles.title}>{t('feedback')}</span>
            <div>
                <Button type={'green'} onClick={onClickMyFeedback}>{t('myFeedback')}</Button>
            </div>
        </div>

        <Form className={styles.form} onSubmit={onSubmit}>
            <div className={styles.formContent}>
                <QuestionType name={"type"} />
                <OrderFiled name="order" typeName="type" />
            </div>

            <div className={styles.desc}>
                <ContentDescribe name="desc" />
            </div>

            <div className={styles.images}>
                <UploadErrorImage name={'images'} />
            </div>

            <div className={styles.submit}>
                <SubmitButton text={t('submit')} loading={isMutating} />
            </div>
        </Form>
    </div>
}


export default FeedBack